export enum EError {
    /**
     * There was an error fetching the customer experience context from the server
     * This happened during the HTTP call and might be a 4xx or 5xx HTTP error, or a timeout
     */
    GetCustomerExperienceContext = 'DC_CES_0',
    /**
     * There was an error fetching the location information from the server
     * This happened during the HTTP call and might be a 4xx or 5xx HTTP error, or a timeout
     */
    GetLocationInformation = 'DC_CES_1',
}
